/** Animated checkmark circle for info-only lesson completion. */
import { motion } from 'motion/react';

export function CompletionCheckmark() {
  const size = 160;

  // Checkmark polyline points (centered in viewBox, drawn at ~60% of size)
  const points = '44,84 70,108 116,58';

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
        {/* Background circle — scales in */}
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={size / 2 - 4}
          fill="var(--f-success)"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 260, damping: 20, delay: 0.3 }}
          style={{ transformOrigin: 'center' }}
        />
        {/* Checkmark — draws in after circle */}
        <motion.polyline
          points={points}
          stroke="white"
          strokeWidth={8}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{
            pathLength: { duration: 0.4, ease: 'easeOut', delay: 0.6 },
            opacity: { duration: 0.01, delay: 0.6 },
          }}
        />
      </svg>
    </div>
  );
}
